import { Button } from "@asosteam/asos-web-component-library-button";
import styles from "./styles";

const SuccessResponse = () => (
  <div className={styles.container}>
    <div className={styles.wrapper}>
      <h2 className="app_barnsley5">BOOM! YOUR ENTRY HAS BEEN SUBMITTED</h2>
      <p className="app_leavesden1">
        {`Thanks for entering, we'll cross our fingers for you!`}
      </p>
      <p className="app_leavesden1">
        Remember to shop with your Mastercard for us to know you have one.
      </p>
      <div>
        <Button elementOverride="a" href="/women">
          Shop Women
        </Button>
        <Button elementOverride="a" href="/men">
          Shop Men
        </Button>
      </div>
    </div>
  </div>
);

export default SuccessResponse;
